import { gql } from '@apollo/client';

import client from '../../../core/services/graphql';

const GET_PROJECT_BY_SHARE_CODE = gql`
  query Project($shareCode: String!) {
    project(shareCode: $shareCode) {
      id
    }
  }
`;

export const getProjectByShareCode = async (shareCode) => {
  const { data } = await client.getClient().query({
    query: GET_PROJECT_BY_SHARE_CODE,
    variables: { shareCode },
  });

  return data;
};

const GET_NOTE_BY_SHARE_CODE = gql`
  query FindNote($shareCode: String!) {
    testSessionNote(shareCode: $shareCode) {
      id
    }
  }
`;

export const getNoteByShareCode = async (shareCode) => {
  const { data } = await client.getClient().query({
    query: GET_NOTE_BY_SHARE_CODE,
    variables: { shareCode },
  });

  return data;
};

const GET_HIGHLIGHT_REEL_BY_SHARE_CODE = gql`
  query FindHighlightReel($shareCode: String!) {
    highlightReel(shareCode: $shareCode) {
      id
    }
  }
`;

export const getHighlightReelByShareCode = async (shareCode) => {
  const { data } = await client.getClient().query({
    query: GET_HIGHLIGHT_REEL_BY_SHARE_CODE,
    variables: { shareCode },
  });

  return data;
};

const GET_REPORT_BY_SHARE_CODE = gql`
  query FindReport($shareCode: String!) {
    report(shareCode: $shareCode) {
      id
    }
  }
`;

export const getReportByShareCode = async (shareCode) => {
  const { data } = await client.getClient().query({
    query: GET_REPORT_BY_SHARE_CODE,
    variables: { shareCode },
  });

  return data;
};
